import { render } from "./LogOutPage.vue?vue&type=template&id=247a52d7&ts=true"
import script from "./LogOutPage.vue?vue&type=script&lang=ts"
export * from "./LogOutPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__